export default __webpack_public_path__ + "static/media/imagine_back.8778573b.gif";